const knownIntegratedBranches = ["main", "staging"];

export default function isIntegratedBranch() {
  return knownIntegratedBranches.includes(process.env.VERCEL_GIT_COMMIT_REF);
}
